module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.04ce8adf.woff2";